import http from '@http/index';



export const checkPromoCode = async (promoCode: string) => {
  const {data} = await http.post('/check-promo-code', {
    promoCode
  });
  return data;
};